export const MuiSnackbarContentTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                alignItems: "flex-start",
                borderRadius: dt.brand.borderRadius.small,
                padding: `${dt.inset.squish.medium.vertical} ${dt.inset.squish.medium.horizontal}`,
                background: dt.color.onSurface.variant,
                boxShadow: dt.elevation.level3,
            },
        },
    };
};
